import { render, staticRenderFns } from "./downloadArea.vue?vue&type=template&id=6b2717c8&scoped=true&"
import script from "./downloadArea.vue?vue&type=script&lang=js&"
export * from "./downloadArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2717c8",
  null
  
)

export default component.exports